const { AxiosAdapter } = require("../http/http-adapter");
const { verifyIfHasErrorInParams } = require("../utils/verify-errors-params");

class GetToken {
  constructor({ accessToken, baseUrl, personId, chargeToken, companyId }) {
    const paramsValid = verifyIfHasErrorInParams({
      accessToken,
      baseUrl,
      personId,
    });
    if (paramsValid) throw new Error(paramsValid);
    this.accessToken = accessToken;
    this.baseUrl = baseUrl;
    this.personId = personId;
    this.chargeToken = chargeToken;
    this.companyId = companyId;
    this.httpClient = new AxiosAdapter(this.baseUrl);
    this.httpClient.setAuthHeader(this.accessToken);
  }

  get() {
    if (this.personId) {
      return this.httpClient.get("/access-token");
    }
    else{
      return this.httpClient.get(`/access-token/${this.companyId}/${this.chargeToken}`);
    }
  }
}

module.exports = {
  GetToken,
};
